export const stepOneData = [
  {
    heading: "Why Use the HDFC Home Loan EMI Calculator?",
    // paras before heading

    infoList: [
      {
        heading: "Precise EMI Calculation: ",
        description:
          "Get an accurate monthly repayment estimate, with both principal and interest breakdown.",
      },
      {
        heading: "Easy-to-Use Interface: ",
        description:
          "This tool is user-friendly and free to use, making it accessible anytime, anywhere.",
      },
      {
        heading: "Visual EMI Breakdown: ",
        description:
          "Understand how much of your EMI goes towards the principal and how much is used for interest.",
      },
      {
        heading: "Transparent Loan Planning: ",
        description:
          "The calculator helps you plan and allocate your budget more effectively with a detailed repayment schedule.",
      },
    ],
  },
];

export const stepTwoData = [
  {
    heading: "HDFC Home Loan EMI Calculator Features",

    tableContent: {
      heading: [
        {
          head: "Loan Type",
        },
        {
          head: "Interest Rate (Starting)",
        },
        {
          head: "Maximum Tenure",
        },
        {
          head: "Processing Fees",
        },
      ],
      row: [
        {
          type: "Home Loan",
          interest: "8.40% p.a.",
          tenure: "Up to 30 years",
          fee: "₹3,000 to ₹15,000",
        },
      ],
    },
  },
];

// export const stepThreeData = [
//   {
//     heading: "Factors Influencing Your EMI and Total Repayment",

//     factorsList: [
//       {
//         heading: "Financial Planning: ",
//         info: "Helps you choose a loan amount and tenure that fits your budget.",
//       },
//       {
//         heading: "Cost Comparison: ",
//         info: "Compare different loan options and lenders for better terms.",
//       },
//       {
//         heading: "Convenient Accessibility: ",
//         info: "Use the calculator from the comfort of your home.",
//       },
//       {
//         heading: "Real-Time Results: ",
//         info: "Get immediate insights to make quick decisions.",
//       },
//     ],
//   },
// ];

export const stepFourData = [
  {
    heading: "Factors Influencing Your EMI with HDFC Bank",

    factorsList: [
      {
        heading: "Loan Amount: ",
        info: "Higher loan amounts result in higher EMIs.",
      },
      {
        heading: "Interest Rate: ",
        info: "A higher interest rate increases both the EMI and the total repayment.",
      },
      {
        heading: "Loan Tenure: ",
        info: "Opting for a longer tenure reduces the EMI but increases the overall interest paid.",
      },
      {
        heading: "Processing Fees: ",
        info: "The processing fee varies based on the loan amount and type of home loan.",
      },
    ],
  },
];
export const stepFiveData = [
  {
    heading: "How to Use the HDFC Bank EMI Calculator?",
    tableContent: {
      heading: [
        {
          head: "Loan Tenure",
        },
        {
          head: "Monthly EMI",
        },
        {
          head: "Total Interest Paid",
        },
        {
          head: "	Total Repayment",
        },
      ],
      row: [
        {
          tenure: "5 years",
          emi: "Higher	",
          interest: "Lower",
          repayment: "Lower",
        },
        {
          tenure: "10 years	",
          emi: "Moderate",
          interest: "Moderate",
          repayment: "Moderate",
        },
        {
          tenure: "15 years",
          emi: "Lower	",
          interest: "Higher",
          repayment: "Higher",
        },
      ],
    },
  },
];
export const stepSixData = [
  {
    heading: "Why Consider APR Over Just Interest Rates?",
  },
];
export const stepSevenData = [
  {
    heading: "HDFC Home Loan EMI Breakdown",
    paraOne: "When you take a home loan, your EMI comprises two parts:",
    infoList: [
      {
        head: "Principal Component: ",
        info: "The portion of your EMI that goes toward repaying the loan amount.",
      },
      {
        head: "Interest Component: ",
        info: "The portion of your EMI that is paid as interest on the borrowed amount.",
      },
    ],
    paraTwo:
      "The EMI amount remains fixed throughout the tenure, but the ratio of principal to interest changes over time. Early in the loan tenure, a larger portion of the EMI goes toward paying the interest, and as you continue repaying, the principal component gradually increases.",
  },
];

export const stepEightData = [
  {
    heading: "MinEmi Tips for Borrowing from HDFC",
    infoList: [
      {
        head: "Interest Rate Negotiation: ",
        info: "A higher credit score (750+) could help you secure a lower interest rate.",
      },
      {
        head: "Consider Loan Tenure: ",
        info: "Choose a loan tenure that fits your budget. Longer tenures result in lower EMIs but higher overall costs due to interest.",
      },
      {
        head: "Prepayment: ",
        info: "If you receive a lump sum amount, consider making a prepayment to reduce the principal amount, which will lower your EMI or reduce the loan tenure.",
      },
      {
        head: "Check for Offers: ",
        info: "HDFC often offers promotional discounts on processing fees or interest rates during special periods, so check for available offers.",
      },
    ],
  },
];
